// ============================================================================
// hvsin Admin Center Contracts
//
// 本包仅包含类型定义和常量，不含实现。
// admin-client-mod 以及第三方业务 Mod 通过此包获取类型信息，
// 通过 hvsin 依赖注入机制获取实际 Service 实例。
// ============================================================================
// ----------------------------------------------------------------------------
// 3. 接口标签常量
// ----------------------------------------------------------------------------
/** IAdminSlotsService 接口标签常量（用于依赖注入） */
export const ADMIN_SLOTS_INTERFACE_TAG = 'IAdminSlotsService';
// ----------------------------------------------------------------------------
// 4. 内置 Section 标识
// ----------------------------------------------------------------------------
/** 内置 Dashboard Section 的 id */
export const DASHBOARD_SECTION_ID = 'dashboard';
/** 管理员中心路由路径 */
export const ADMIN_PATH = '/admin';
//# sourceMappingURL=index.js.map